import React from 'react';
import { Modal, Collapsible, CollapsibleItem, Icon } from "react-materialize";
// import { withTranslation } from 'react-i18next';
import { compose } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { t } from "i18next";
// import ReactTableBuilder from "../../../utils/reactTableBuilder";
import BodyTestQcView from "./components/bodyTextQcView"

function TestQcViewModal(props) {
  const { isOpened, onCloseStart, camera } = props;
  
  return (
    <Modal
      open={isOpened}
      header={t('testQcView.title')}
      options={{
        onCloseStart: onCloseStart,
      }}
      className="large-modal"
    >
      <BodyTestQcView camera={camera} />
    </Modal>
  );
}


TestQcViewModal.propTypes = {
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
  };
  const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
  });
  
  export default compose(
    connect(
      mapStateToProps,
    )
)(TestQcViewModal);
